type Props = { size?: "sm" | "md" | "lg"; className?: string };

export function Spinner({ size = "md", className = "" }: Props): JSX.Element {
  const sizeClasses = {
    sm: "h-4 w-4 border-2",
    md: "h-6 w-6 border-2",
    lg: "h-10 w-10 border-4",
  };
  return (
    <div
      className={`inline-block animate-spin rounded-full border-accent-primary border-t-transparent ${sizeClasses[size]} ${className}`}
      role="status"
      aria-label="Loading"
    />
  );
}
